<template>
  <div class="registration-modal">

    <div class="modal-header">
      <h1 class="headline" v-text="$t('invoice-generation-modal-headline')"></h1>
      <h2 class="subheadline" v-text="$t('invoice-generation-modal-subheadline')"></h2>
    </div>
    <div class="oido-modal-content has-padding">
      <OidoAddressInput :label="$t('invoice-generator-billing-address-label')" :errors="errors.billingAddress"
        v-model="billingAddress"></OidoAddressInput>
    </div>
    <div class="buttons">
      <ion-button class="note-button negative" color="dark" fill="clear" @click="cancel"
        v-text="$t('cancel-button-label')"></ion-button>
      <oido-button class="get-code-button" @click="createInvoice" :show-spinner="processing" :primary="true"
        buttonStyle="solid" :label="$t('invoice-generation-modal-create-button-label')"></oido-button>
    </div>
  </div>
</template>

<script setup>
import OidoButton from '../components/OidoButton.vue';
import {
  IonButton,
  modalController
} from "@ionic/vue";
import validateAddress from '../helpers/validateAddress';

import config from "../../config"
import axios from "axios";

import Validator from "validatorjs";
import invoiceService from "../composables/invoiceService";
import OidoAddressInput from '../components/OidoAddressInput.vue';
import customerService from '../composables/customerService';
import cartService from '../composables/cartService';

</script>
<script>
export default {
  props: ["order"],
  computed: {

  },
  data() {
    return {
      billingAddress: {},
      errors: {},
      success: false,
      processing: false,
      downloadingReceipt: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.prefillBillingAddress()
    })
  },
  methods: {
    prefillBillingAddress() {
      let customersAddress = null
      if (customerService.customer && customerService.customer.value) {
        customersAddress = JSON.parse(JSON.stringify(customerService.customer.value.billingAddress ? customerService.customer.value.billingAddress : {}))
      }
      //if its an empty object set it to null
      if (customersAddress && Object.values(customersAddress).length == 0) {
        customersAddress = null
      }

      if (!customersAddress && cartService.deliveryAddress && cartService.deliveryAddress.value) {
        customersAddress = JSON.parse(JSON.stringify(cartService.deliveryAddress.value ? cartService.deliveryAddress.value : {}))
      }
      this.billingAddress = customersAddress ? customersAddress : {}
    },
    cancel() {
      modalController.dismiss(false);
    },
    async downloadReceipt(receiptUrl) {
      if (this.downloadingReceipt) {
        return
      }
      this.downloadingReceipt = true;

      let response = await axios.post(receiptUrl, {}, {
        responseType: "arraybuffer",
      });

      let filename = this.order.id + '.pdf';

      this.downloadingReceipt = false;
      const link = document.createElement("a");
      const blob = new Blob([response.data]);
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    },
    async createInvoice() {
      this.errors = {}
      this.processing = true

      let rules = {}
      let data = {}

      let validation = new Validator(data, rules);
      validation.setAttributeNames({});

      if (validation.fails()) {
        this.errors = validation.errors.errors
      }

      let validationResult = validateAddress(this.billingAddress, this.$t)
      if (!validationResult.passed) {
        Object.assign(this.errors, { billingAddress: validationResult.errors })
      }


      //validate vat Id and name if its a company address
      if (this.billingAddress.isCompany) {
        let { data } = await axios.post(config.apiUrl + "/api/taxes/validateTaxId", this.billingAddress);

        if (data) {
          if (data.errors && Object.keys(data.errors).length > 0) {
            Object.assign(this.errors, { billingAddress: data.errors })
          }
          if (data.data && data.data.name) {
            this.billingAddress.name = data.data.name
          }
        }
      }


      if (this.errors && Object.keys(this.errors).length > 0) {
        this.processing = false
        return
      }

      let result = await invoiceService.createInvoiceFromOrder(this.order, { billingAddress: this.billingAddress, ...data })

      if (result && result.invoiceId) {
        let invoicePDFUrl = config.apiUrl + '/api/pdf/invoice/' + result.invoiceId + '.pdf'
        await this.downloadReceipt(invoicePDFUrl)
      }

      this.processing = false

      if (!result || result.errors) {
        if (result && result.errors) {
          // a correctable error occured
          this.errors = result ? result.errors : {}
        } else {
          //some other error occured
          this.cancel()
        }
      }
      modalController.dismiss(true)
    },
  },
}
</script>
<style scoped>
.registration-modal {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: white;

}

.registration-modal .oido-modal-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
  padding: 0.2rem;
  padding: 1rem 2rem;
}


.registration-modal .oido-modal-content .oido-address-input {
  padding: 0;
  margin: 0;
}

.registration-modal .modal-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 2rem 2rem 0rem;
}

.registration-modal .modal-header .headline {
  margin-top: 0;
  font-size: 1.2rem;
  margin-bottom: 0.3rem;
}

.registration-modal .modal-header .subheadline {
  margin-top: 0;
  font-size: 1rem;
  color: #666;
}

ion-item {
  margin-bottom: 2rem;
}

.input-line {
  width: 100%
}

ion-checkbox::part(label) {
  text-wrap: wrap;
}

.registration-modal .buttons {
  display: flex;
  align-items: center;
  justify-content: end;
  width: 100%;
  padding: 1rem 2rem 1.5rem;
}

.registration-modal .buttons ion-button {
  margin: 0 0.5rem;
}
</style>